import Close from '@oneflare/flarekit/lib/components/icons/Close';
import MagnifyGlass from '@oneflare/flarekit/lib/components/icons/MagnifyGlass';
import media from '@oneflare/flarekit/lib/libs/media';
import { styled } from 'styled-components';

export const NavigationWrapperStyled = styled.section.attrs(({ className }) => ({
  className
}))`
  &.smUp{
    display: none;

    ${media.smUp`
      display: block;
    `}
  }

  &.smDown{
    display: block;

    ${media.smUp`
      display: none;
    `}
  }

  background-color : ${({ theme }) => theme.color.white};

  ${media.smUp`
    background-color: ${({ theme }) => theme.color.tin};
    padding: 16px 20px;
  `}

  ${media.mdUp`
    padding: 16px 40px;
  `}
`;

export const NavigationStyled = styled.nav`
  display: flex;
  position: relative;
  overflow-x: auto;
  padding: 0 0 32px;
  white-space: nowrap;

  &::-webkit-scrollbar {
    display: none;
  }

  ${media.smUp`
    padding: 0;
  `}

  ${media.xlUp`
    margin: 0 auto;
    padding: 0 40px;
    max-width: 1440px;
  `}
`;

export const SearchInputStyled = styled.input`
  width: 100%;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.color.charcoal};
  font-size: 16px;
  font-family: lato;
  margin: 4px 0;
  padding: 8px 32px 4px;

  &:focus,
  &:active,
  &:hover {
    outline: none;
  }

  ${media.xlUp`
      padding: 8px 62px 4px;
  `}
`;

export const SearchWrapperStyled = styled.div`
  position: relative;
  margin: auto;
`;

export const ClearBtnStyled = styled.div`
  position: absolute;
  top: 12px;
  right: 0;
`;

export const CloseStyled = styled(Close).attrs(({ theme }) => ({
  fill: theme.color.silver,
  kind: 'hollow',
  width: '16px',
  height: '16px'
}))``;

export const SearchBtnStyled = styled.div`
  position: absolute;
  top: 12px;

  ${media.xlUp`
    left: 32px;
  `}
`;

export const SearchMenuBtnStyled = styled.div`
  position: relative;
  top: 12px;
  right: 0;

  ${media.lgUp`
    position: absolute;
  `}
`;

export const MagnifyGlassStyled = styled(MagnifyGlass).attrs(({ theme }) => ({
  fill: theme.color.gunMetal,
  kind: 'hollow',
  width: '20px',
  height: '20px'
}))``;
